module.exports = __webpack_public_path__ + "static/images/list-o-a.c67dbee.png";